import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemAlcohol = function IconSystemAlcohol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16.5 13.1h-5.75v5.5h5.75M10.125 4.3h3.75M10.125 1v7c-1.25.55-2.625 2.35-2.625 4v11h9V12c0-1.65-1.375-3.45-2.625-4V1z"
  }));
};